// Function to calculate responsive size
export const getResponsiveSize = (size, baseWidth = 1920) => {
  if (typeof window === "undefined") return size;
  const screenBase = window.innerWidth <= 768 ? 428 : baseWidth; // Use 375px base for mobile
  return (window.innerWidth * size) / screenBase;
  // return `${size}px`;
};

export const getResponsiveHeight = (size, baseWidth = 1920) => {
  if (typeof window === "undefined") return size;
  const screenBase = window.innerWidth <= 768 ? 428 : baseWidth; // Use 375px base for mobile
  return (window.innerWidth * size) / screenBase;
};
